import { getQueryObj } from '@/utils/common/query.js'
import { getGlobalParams } from './bridge.js'
import { getLanguage, getLocale } from '@/utils/common/locale.js'
import bridgeInit from '@didi/sailing-bridge'
import { postFormData } from '@/utils/request/request'
import { getOSInfo, OS_TYPE_JSON } from '@/utils/passport/h5passport.js'
import store from '@/store'
import PACKAGE_JSON from '../../../package'
import { inNative } from '@/utils/common/env.js'

export function isFromBDAPP() {
  const { fromBDAPP = 0 } = getQueryObj()
  const { fromBDAPP: storeFromBDAPP } = store?.state?.globalParams || {}
  return fromBDAPP || storeFromBDAPP
}

export async function setFromBDAPPGlobalConfig(resolve) {
  const {
    // BDAPP 前端提供
    fromBDAPP,
    locale = '',
    lang = '',
    // BDAPP 客户端提供
    terminalType = 1,
    bizId = 395,
    clientType = 4,
    appVersion = '1.2.5',
    osVersion = '',
    osType = 11,
    deviceType = '',
    // CRM 后端
    shopBusinessType = 1,
    businessType = 1,
    originType = 5,
    brand = '',
    cityId = '',
    countyId = '',
    countyGroupId = '',
    countryCode = '',
    contractorId = '',
    uid = '',
    username = '',
    shopId = '',
    sign = '',
  } = getQueryObj()
  // 设置国家
  store.commit('UPDATE_CURRENT_COUNTRY', countryCode)

  const localGlobalParams = await getGlobalParams()
  const version = PACKAGE_JSON.version.split('-')[0]
  const globalParams = {
    ...localGlobalParams,
    // BDAPP 前端提供
    locale: locale || getLocale(),
    lang: lang || getLanguage().long,
    // BDAPP 客户端提供
    terminalType: terminalType || 1, // 端类型信息 app 1： 独立端 2：嵌入式 3 : pad 4 : exe 5: web 6: 轻应用 miniProgram7 : 支付宝8 :微信
    bizId,
    clientType, // 1:R, 2:国内嵌入端C, 3:B, 4:BD，5:国内独立端C )，6：国际化独立端C ，7：国际嵌入式C，8：99独立端C ，9：99嵌入端C
    appVersion,
    webVersion: version,
    osVersion,
    osType: osType || OS_TYPE_JSON[getOSInfo() || 'default'],
    deviceType,
    // CRM 后端
    fromBDAPP,

    businessType: shopBusinessType || businessType,
    shopBusinessType,
    originType,
    brand,
    cityId,
    countyId,
    countyGroupId,
    countryCode,
    contractorId,
    uid,
    username,
    shopId,
    sign,
  }
  // 设置全局参数
  store.commit('UPDATE_GLOBAL_PARAMS', globalParams)

  Promise.all([getContractor()])
    .then(([results]) => {
      // 初始化bridge监控
      bridgeInit({
        module: 'bH5',
        Omega: window.Omega,
        params: globalParams,
        options: { showLog: true },
      })
      window.BridgeTraceInit && window.BridgeTraceInit(window.Omega, globalParams, {
        showLog: true,
        shouldReport: inNative,
      })
      const { data = {} } = results || {}
      const { contractors = [] } = data || {}
      const contractorInfo = getContractorById(contractors || [], contractorId)
      const { shops = [] } = contractorInfo
      store.commit('UPDATE_CURRENT_CONTRACTOR', contractorInfo)
      store.commit('UPDATE_CURRENT_SHOP', {
        ...(getShopByID(shops || [], shopId) || {}),
        businessType: globalParams.businessType,
        countryCode: globalParams.countryCode,
      })
      resolve()
    })
    .catch(() => {})
    .finally(() => {
      window.Soda && window.Soda.toggleTitleBar && window.Soda.toggleTitleBar(1)
    })
}

export function canOpenPageByWebUrl(url = '') {
  const schame = ['gsodamerchant://', 'bsodamerchant://']
  if (!url) return false
  return schame.every(item => url?.indexOf(item) < 0)
}

function getContractor() {
  return postFormData('/auth/auth/getContractor', {})
}
function getContractorById(contractors = [], contractorId) {
  return contractors.find(it => it.contractorId === contractorId)
}
// 登陆时获取必需的门店信息
function getShopByID(shops = [], shopId = '') {
  return shops.find(it => it.shopId === shopId)
}

// http://localhost:8081/zh-MX/item/list?fromBDAPP=1&shopId=5764607661912621097&contractorId=5764607759597961242&cityId=52140500&countryCode=MX&countyGroupId=521405000001&countyId=52140511&brand=2&uid=1482914&username=xiezuobing&shopBusinessType=1
